export const API_BASE_URL = (import.meta as any).env.VITE_API_BASE_URL;
export const PKG = (import.meta as any).env.VITE_PKG;
export const GOLD_TREATURY = (import.meta as any).env.VITE_GOLD_TREATURY;